var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 14 9","width":"14","height":"9"}},[_c('path',{attrs:{"fill":"currentColor","d":"M1.02 2.048C.438 1.405.893.375 1.76.375h10.48c.868 0 1.323 1.03.74 1.673L7.74 7.81a1 1 0 0 1-1.48 0L1.02 2.048z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }